import { Injectable } from '@angular/core';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';

@Injectable({
  providedIn: 'root'
})
export class FirebaseCrashlyticsService {

  constructor() { }

  async setEnabled() {
    try{
      await FirebaseCrashlytics.setEnabled({
        enabled: true,
      });
    } catch(error){
      console.log('error ====>', error);
    }

  };

  async crash(msg = 'Test manual crash') {
    try{
      await FirebaseCrashlytics.crash({ message: msg });
    } catch(error){
      console.log('error ====>', error);
    }
  }
}
